import { render, staticRenderFns } from "./CourseCreator.vue?vue&type=template&id=c902bf38&scoped=true&"
import script from "./CourseCreator.vue?vue&type=script&lang=ts&"
export * from "./CourseCreator.vue?vue&type=script&lang=ts&"
import style0 from "./CourseCreator.vue?vue&type=style&index=0&id=c902bf38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c902bf38",
  null
  
)

export default component.exports